<template>
  <img v-if="affiliatePath !== ''" :src=affiliatePath width="1" height="1">
</template>
<script>
export default {
  props: ["affiliatePath"]
};
</script>

